
import FunnelStages from "./comonents/funnel-stages.vue";
import { LeadFunnelDataSource, ListDataSource } from "@/data/List/ListDataSource";
import { LeadFunnelObjectDataSource, ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { mdiTunnel } from "@mdi/js";
import { Vue, Component } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
  components: {
    draggable,
    FunnelStages
  }
})
export default class Kanban extends Vue {
  // поиск
  search = ""
  performSearch() {
    console.log("Поиск по:", this.search);
  }


  funnelDataSource:LeadFunnelDataSource = new LeadFunnelDataSource({
    className:"LeadFunnel",
    config: {
      orderFieldName:"Priority",
      orderFieldDirection:"ASC",
    }
  })

  clientDataSource:ListDataSource = new ListDataSource({
    className:"PrivateClient",
    config:{}
  })

  dataSource:LeadFunnelObjectDataSource = new LeadFunnelObjectDataSource({
    className:"LeadFunnel",
    id:0,
    config:{}
  })
  
  leadClassDataSource:ListDataSource = new ListDataSource({
      className:"LeadClass",
      config:{}
  })


  //табы
  activeTab = 'deals';
  tabs = [
    { name: 'deals', label: 'Лиды', content: 'Содержимое вкладки Сделки' },
    { name: 'goods', label: 'Сделки', content: 'Содержимое вкладки Товары и Склады' },
  ]

  icons = {
    mdiTunnel
  }
  editing = false;
  title = 'Заявки'
  startEditing() {
    this.editing = true;
    this.$nextTick(() => {
      const input = this.$refs.titleInput as Vue & { focus: () => void };
      if (input && typeof input.focus === "function") {
        input.focus();
      }
    });
  }
 


  getStatusColor(status) {
    switch (status) {
      case 'New': return '#3d97e4';
      case 'In Progress': return 'orange';
      case 'Done': return '#2eaa42';
      default: return 'grey';
    }
  }

  async mounted(){
    await Promise.all([
      this.funnelDataSource.get(),
      this.dataSource.getDefault(),
      this.leadClassDataSource.get(),
    ])

  }
  

  async updateFunnel(item:any){
    this.dataSource.id = item.id;
    await this.dataSource.get();
  }
}
